import { b as __rest, a as __assign } from '../../../tslib.es6-a39f91fc.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { BottomModal } from '../bottomModal/index.js';
import { RegularModal } from '../regularModal/index.js';
import { s as styleInject } from '../../../style-inject.es-1f59c1d0.js';
import '../../../index-6ea95111.js';
import '../genericModal/index.js';
import '../../button/index.js';
import '../../icon/icons/X.js';
import '../../icon/IconWrapper/IconWrapper.js';
import '../../../index-171a0108.js';
import '../../../index-dd80248b.js';

var css_248z = "@media (min-width: 34rem) {\n  .style-module_mobile__3k175 {\n    display: none;\n  }\n}\n@media (max-width: 34rem) {\n  .style-module_mobile__3k175 {\n    display: block !important;\n  }\n}\n\n@media (max-width: 34rem) {\n  .style-module_desktop__2lclr {\n    display: none;\n  }\n}";
var styles = {"mobile":"style-module_mobile__3k175","desktop":"style-module_desktop__2lclr"};
styleInject(css_248z);

var BottomOrRegularModal = function (_a) {
    var isOpen = _a.isOpen, props = __rest(_a, ["isOpen"]);
    var mobileRef = useRef(null);
    var _b = useState('desktop'), visibleSize = _b[0], setVisibleSize = _b[1];
    var handleResize = function () {
        setVisibleSize(mobileRef.current !== null &&
            window.getComputedStyle(mobileRef.current).display !== 'none'
            ? 'mobile'
            : 'desktop');
    };
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (jsxs(Fragment, { children: [jsx("div", { className: styles.mobile, ref: mobileRef, children: visibleSize === 'mobile' && jsx(BottomModal, __assign({}, props, { isOpen: isOpen })) }), visibleSize === 'desktop' && (jsx("div", { className: styles.desktop, children: jsx(RegularModal, __assign({}, props, { isOpen: isOpen })) }))] }));
};

export { BottomOrRegularModal };
//# sourceMappingURL=index.js.map
